import classNames from 'classnames'
import React from 'react'
import { NameType, Payload, ValueType } from 'recharts/types/component/DefaultTooltipContent'

import { shortFormatNumber } from '../../../util'

type ChartTooltipProps = {
  isActive?: boolean
  activeKey?: string
  payload: Payload<ValueType, NameType>[] | undefined
}
export default function ChartTooltip({ isActive, activeKey, payload }: ChartTooltipProps) {
  if (!isActive || !payload || payload.length === 0 || !payload.some(({ value }) => value)) return null

  return (
    <div className="relative -top-8 space-y-1.5 rounded-md border border-secondary bg-primary p-2.5 font-sans text-2xs leading-4 text-muted-2">
      {payload.map((data) =>
        !data.value ? null : (
          <div
            key={data.name}
            className={classNames('flex items-center justify-between space-x-2.5', {
              'text-default font-medium': data.name === activeKey,
            })}
          >
            <span className="flex min-w-56 items-center space-x-1.5">
              <span className="block h-1.5 w-1.5 rounded-full" style={{ backgroundColor: data.color }}></span>
              <span>{data.name}</span>
            </span>
            <span className="w-14 text-right">{shortFormatNumber(+data.value)}</span>
          </div>
        )
      )}
    </div>
  )
}
